export default __webpack_public_path__ + "static/media/Ring of the Arsonist.137285cb.jpg";